import {Button, Grid, Typography} from "@material-ui/core";
import {useDispatch} from "react-redux";
import PropTypes from "prop-types";
import {useEffect, useRef} from "react";
import ButtonWithProgress from "../../../../../../ui/buttons/button-with-progress/ButtonWithProgress";
import * as actions from "../../../../../../../store"
import Summary from "./summary/Summary";
import {mapToSummaryObj} from "./ConfirmStepHelper";
import {apnTypeEnum} from "../initial-step/InitialStepHelper";

const ConfirmDialogContent = (props) => {
    const showSummary = props.changeApnForm.apnType !== apnTypeEnum.PUBBLICO

    return (
        <>
            <Typography variant="subtitle2">
                La tipologia di APN passerà
                da {props.currentApn} a {props.apnOptions.find(rb => rb.value === props.changeApnForm.apnType).text}
            </Typography>

            {showSummary ? <Summary summaryForm={mapToSummaryObj(props.changeApnForm)}/>
                : null}
        </>
    )
}

ConfirmDialogContent.propTypes = {
    changeApnForm: PropTypes.shape({
        apnType: PropTypes.string.isRequired,
        apnName: PropTypes.string.isRequired,
        vrfName: PropTypes.string.isRequired
    }).isRequired,
    apnOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
    })).isRequired,
    currentApn: PropTypes.string.isRequired
}

const ConfirmDialogActions = ({moveToConfirm, ...props}) => {
    const dispatch = useDispatch()
    const isFirstRun = useRef(true)

    useEffect(() => {
        if (!props.loading && !props.error && !isFirstRun.current)
            moveToConfirm()
        isFirstRun.current = false
    }, [props.loading, props.error, moveToConfirm])

    const changeApn = () => {
        dispatch(actions.changeApn(props.changeApnForm, props.iccId))
    }

    return (
        <Grid container
              justifyContent="space-between">
            <Button variant="outlined"
                    color="primary"
                    onClick={props.moveBack}
                    disabled={props.loading}>
                Annulla
            </Button>

            <ButtonWithProgress handleClick={changeApn}
                                text="Conferma"
                                disabled={props.loading}
                                loading={props.loading}/>
        </Grid>
    )
}

ConfirmDialogActions.propTypes = {
    moveToConfirm: PropTypes.func.isRequired,
    moveBack: PropTypes.func.isRequired,
    changeApnForm: PropTypes.shape({
        apnType: PropTypes.string.isRequired,
        apnName: PropTypes.string.isRequired,
        vrfName: PropTypes.string.isRequired
    }).isRequired,
    iccId: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
}

export {ConfirmDialogActions, ConfirmDialogContent}
